import { createApp } from 'vue';
import './init';
// Install MonacoEnvironment.getWorker via side effect — must run BEFORE any Monaco
// import resolves. Only affects users of the planning editor; other pages are
// unaffected because Monaco is lazy-loaded on the /plan-editor route.
import './planning/lib/monaco-workers';
import 'vee-validate';
import Apollo from './plugins/graphql';
import App from './App.vue';
import { ValidationRules } from '@/common/';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import { createPinia, setMapStoreSuffix } from 'pinia';
import '@mdi/font/css/materialdesignicons.css';
import { createVuetify } from 'vuetify';
import 'vuetify/styles';
import ganttastic from '@infectoone/vue-ganttastic';

const vuetify = createVuetify({
    components,
    directives,
    theme: {
        defaultTheme: 'dark', // Vuetify 4 defaults to 'system', explicitly setting to 'dark'
        themes: {
            dark: {
                colors: {
                    secondary: '#9E9E9E', // grey
                },
            },
        },
    },
    aliases: {
        VBtnAffirmative: components.VBtn,
        VBtnDestructive: components.VBtn,
    },
    defaults: {
        VBtn: {
            variant: 'flat',
        },
        VBtnAffirmative: {
            color: 'green',
        },
        VBtnDestructive: {
            color: 'red',
        },
    },
});

setMapStoreSuffix('');
const pinia = createPinia();

// Must occur after Pinia is used
import createRouterInstance from './router';

async function mountApp() {
    const router = await createRouterInstance();
    const app = createApp(App);
    app.use(pinia);
    app.use(vuetify);
    app.use(ValidationRules);
    app.use(Apollo.apolloProvider); // For Options API components

    // Provide Apollo client for Composition API components
    app.provide(Apollo.DefaultApolloClient, Apollo.getClient());

    app.use(ganttastic);
    app.use(router);
    app.mount('#app');

    // Keep the CloudFront chart-tile signed cookies fresh — mint
    // once immediately, then re-mint every 6 h (well inside the
    // 12-h cookie lifetime).  Only fires when an access token is
    // present, so pre-login mounts are a no-op.  See
    // authentication/tileAccessCookies.ts.
    const { startTileAccessRenewal } = await import('@/authentication/tileAccessCookies');
    startTileAccessRenewal();
}

mountApp(); // Call the async function to mount the app
